import styled from 'styled-components';

import media from 'apps/auth/theme/media';

export const TableContainer = styled.div`
    margin-bottom: ${(props) => (props.indent ? props.indent : null)};
`;
export const TableRowContainer = styled.div`
    display: flex;
    margin-bottom: ${(props) => (props.pseudoTable ? '16px' : '32px')};
    text-align: ${(props) => (props.pseudoTable ? 'left' : null)};
    cursor: ${(props) => (props.onClick ? 'pointer' : null)};

    &:last-child {
        margin-bottom: 0;
    }
`;
export const TableRowTitle = styled.div`
    width: ${(props) => (props.pseudoTable ? null : '38%')};
    flex-shrink: 0;
    margin-right: 24px;
    display: flex;

    ${media.desktop1920} {
        margin-right: 32px;
    }
`;
export const TableRowContent = styled.div`
    width: ${(props) => (props.pseudoTable ? '100%' : null)};
    flex: ${(props) => (props.pseudoTable ? '1' : null)};
    display: flex;
    align-items: center;
    justify-content: ${(props) => (props.pseudoTable ? 'end' : null)};
`;
